<template>
  <div class="pub-info-list-item">
    <p class="info-label">{{ label }}</p>
    <div class="info_value_content">
      <p class="info-value">{{ value }}</p>
      <p class="info-unit">{{ unit }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pubInfoListUnitItem',
  props: {
    label: {
      default: '',
      type: String,
    },
    value: {
      default: '',
    },
    unit: {
      default: '',
      type: String,
    },
  },
};
</script>

<style lang="less" scoped>
.pub-info-list-item {
  width: 403px;
  height: 42px;
  box-sizing: border-box;
  padding: 0 20px;
  .backgroundImage('@/assets/images/infoBg.png');
  .displayFlex(space-between, center);
  .info-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .info-value {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 700;
    color: #ffffff;
  }
  .info-unit {
    margin-left: 3px;
    font-size: 12px;
    color: #ffffff;
  }
  .info_value_content {
    display: flex;
    align-items: flex-end;
  }
}
</style>
